import { seoContent } from '@/mocks/seoContent';

export default function ValueSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            {seoContent.valueTitle}
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            {seoContent.valueDescription}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoContent.benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl p-6 md:p-7 hover:bg-background-50/80 transition-all duration-300 group cursor-default"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-100 flex items-center justify-center text-accent-600 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${benefit.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-5 text-foreground-950 font-heading text-lg md:text-xl font-semibold">
                {benefit.title}
              </h3>
              <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}